import React, { useState, useEffect } from 'react';
import { SliderData } from './SliderData';
import { FaArrowAltCircleRight, FaArrowAltCircleLeft } from 'react-icons/fa';
import LazyLoad from 'react-lazyload';

const ImageSlider = ({ slides }) => {
  const [current, setCurrent] = useState(0);

  const length = slides.length;
  useEffect(() => {
    const toggle = setInterval(() => {
      setCurrent(current === SliderData.length - 1 ? 0 : current + 1);
    }, 3000);

    return () => clearInterval(toggle);
  })

  const nextSlide = () => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  if (!Array.isArray(slides) || slides.length <= 0) {
    return null;
  }

  return (
    <section className='slider'>
      <FaArrowAltCircleLeft className='left-arrow' onClick={prevSlide} />
      <FaArrowAltCircleRight className='right-arrow' onClick={nextSlide} />
      {SliderData.map((slide, index) => {
        return (
          <div
            className={index === current ? 'slide active' : 'slide'}
            key={index}
          >
            {index === current && (
              <LazyLoad>
                <img
                  src={slide.image}
                  alt='travel image'
                  className='img'
                />
              </LazyLoad>
            )}
          </div>
        );
      })}
    </section>
  );
};

export default ImageSlider;